module.exports = __webpack_public_path__ + "img/remax-saarlouis-sameline.65c936eb.png";